import React from "react";
import arrowUpBlack from "../../../assets/imgs/arrow-up-black.svg";
import arrowDownBlack from "../../../assets/imgs/arrow-down-black.svg";

interface CounterControlProps {
  value: number;
  onChange: (newValue: number) => void;
  min?: number;
  max?: number | null;
}

const CounterControl: React.FC<CounterControlProps> = ({
  value = 0,
  onChange,
  min = 0,
  max = null,
}) => {
  const handleIncrement = () => {
    // Only check against max if it's provided
    if (max === null || value < max) {
      onChange(value + 1);
    }
  };

  const handleDecrement = () => {
    if (value > min) {
      onChange(value - 1);
    }
  };

  return (
    <div className="flex items-center justify-center h-[28px]   bg-white rounded-[24px] min-w-[72px] gap-3">
      <div onClick={handleIncrement} className="pl-[8px] py-[4px] w-full">
        <img src={arrowUpBlack} alt="Increment" />
      </div>
      <div className="py-[4px] w-full flex items-center justify-center">
        <p className="text-[12px] text-black font-medium">{value}</p>
      </div>
      <div onClick={handleDecrement} className="pr-[8px] py-[4px] w-full">
        <img src={arrowDownBlack} alt="Decrement" />
      </div>
    </div>
  );
};

export default CounterControl;
